export default {
  paged: {
    select: 'id,name,isActive,description',
    searchSelect: ['name', 'description'],
    orderBy: 'name asc',
  },
  item: {
    select: 'id,name,isActive,description',
  },
  itemDetail: {
    select: 'id,name,isActive,description,created,updated',
    expand: {
      userCreator: { select: 'fullName' },
      userModifier: { select: 'fullName' },
    },
  },
};
